import { useQuery } from '@tanstack/react-query';

import { FileDownloadUrlResponse } from '@Models';
import { bopsApi } from '@Network';

// Presigns live 3600s (agents.py); refresh well before a cached URL can expire.
const INLINE_URL_STALE_MS = 50 * 60 * 1000;

interface UseFileInlineUrlParams {
  conversationId: string;
  timestamp: string;
  fileName: string;
  enabled?: boolean;
}

const fileInlineUrlKey = (conversationId: string, timestamp: string, fileName: string) =>
  ['agent-file-inline-url', conversationId, timestamp, fileName] as const;

export const useFileInlineUrl = ({ conversationId, timestamp, fileName, enabled = true }: UseFileInlineUrlParams) =>
  useQuery<FileDownloadUrlResponse>({
    queryKey: fileInlineUrlKey(conversationId, timestamp, fileName),
    queryFn: () => bopsApi.getFileDownloadUrl(conversationId, timestamp, fileName, true),
    enabled,
    staleTime: INLINE_URL_STALE_MS,
    gcTime: INLINE_URL_STALE_MS,
    retry: 1,
    refetchOnWindowFocus: false,
  });

export default useFileInlineUrl;
